import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import jwtAuthAxios from 'services/jwtAuth';

export const getListPresensiMhs = createAsyncThunk("presensi/getListPresensiMhs",
    async(payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const response = await jwtAuthAxios.post('v1/presensi/list/tipe1',payload);
            return response.data;
        } catch(err){
            return rejectWithValue(err?.response?.data?.message || err?.message || 'error')
        }
    }
);

export const getListPresensiMhsAll = createAsyncThunk("presensi/getListPresensiMhsAll",
    async(payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const response = await jwtAuthAxios.post('v1/presensi/list/tipe2',payload);
            return response.data;
        } catch(err){
            return rejectWithValue(err?.response?.data?.message || err?.message || 'error')
        }
    }
);

export const getListMasterPresensi = createAsyncThunk("presensi/getListMasterPresensi",
    async (_, { rejectWithValue }) => {
        try {
            const token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const response = await jwtAuthAxios.get('v1/master/presensi');
            return response.data;
        } catch (e) {
            return rejectWithValue(e?.response?.data?.message || e?.message || 'error')
        }
    }
);

export const savePresensiMhs = createAsyncThunk("presensi/savePresensiMhs",
    async(payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const response = await jwtAuthAxios.post('v1/map/presensi/mhs',payload);
            return response.data;
        } catch(err){
            return rejectWithValue(err?.response?.data?.message || err?.message || 'error')
        }
    }
);

export const savePresensiMhsMultiple = createAsyncThunk("presensi/savePresensiMhsMultiple",
    async(payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const response = await jwtAuthAxios.post('v1/map/presensi/mhs/multiple',payload);
            return response.data;
        } catch(err){
            return rejectWithValue(err?.response?.data?.message || err?.message || 'error')
        }
    }
);


const initialState = {
    loading : false,
    dataPresensiMhsAll : [],
    dataPresensiMhs : [],
    listPresensi : [],
    response : {}
}

const presensiSlice = createSlice({
    name:"presensiSlice",
    initialState: initialState,
    extraReducers: {
        [getListPresensiMhsAll.pending] : (state, action) => {
            state.loading = true;
        },
        [getListPresensiMhsAll.fulfilled] : (state, action) => {
            state.dataPresensiMhsAll = action.payload;
            state.loading = false;
        },
        [getListPresensiMhsAll.rejected] : (state, action) => {
            state.loading = false;
        },
        
        [getListPresensiMhs.pending] : (state, action) => {
            state.loading = true;
        },
        [getListPresensiMhs.fulfilled] : (state, action) => {
            state.dataPresensiMhs = action.payload;
            state.loading = false;
        },
        [getListPresensiMhs.rejected] : (state, action) => {
            state.loading = false;
        },

        [savePresensiMhs.pending] : (state, action) => {
            state.loading = true;
        },
        [savePresensiMhs.fulfilled] : (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        [savePresensiMhs.rejected] : (state, action) => {
            state.loading = false;
        },

        [savePresensiMhsMultiple.pending] : (state, action) => {
            state.loading = true;
        },
        [savePresensiMhsMultiple.fulfilled] : (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        [savePresensiMhsMultiple.rejected] : (state, action) => {
            state.loading = false;
        },

        [getListMasterPresensi.pending] : (state, action) => {
            state.loading = true;
        },
        [getListMasterPresensi.fulfilled] : (state, action) => {
            state.listPresensi = action.payload;
            state.loading = false;
        },
        [getListMasterPresensi.rejected] : (state, action) => {
            state.loading = false;
        },
    }
})

export const presensiSelector = (state) => state.presensi;
export default presensiSlice.reducer;
